<template>
	<expose class="game-demo-expose" :active="game != null" v-on:expose-close="$root.$data.gameDemo = null">
		<game-demo class="game-demo-expose__game" ref="gameWindow" :game="game"></game-demo>
	</expose>
</template>

<script>
import Expose from '../molecules/Expose'
import GameDemo from '../molecules/GameDemo'

export default {
	name: 'GameDemoExpose',
	components: {
		Expose,
		GameDemo
	},
	data () {
		return {
			// aspectRatio: (562/760),
			// spacing: 40
		}
	},
	props: {
		game: Object
	},
	computed: {
		// gameWidth: function()
		// {
		// 	var self = this;
		// 	var gameWindow = self.$refs.gameWindow;
		// 	var winWidth = self.$root.$data.windowWidth;
		// 	var winHeight = self.$root.$data.windowHeight;
		// 	var winAspectRatio = winHeight / winWidth;
		// 	var chosenAR = Math.max(self.aspectRatio, winAspectRatio);

		// 	return (winHeight - (2 * self.spacing)) * (1 / chosenAR);
		// }
	},
	created: function()
	{
	},
	mounted: function()
	{
	},
	methods: {
	}
}
</script>

<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".game-demo-expose";
	#{$c}
	{
		background-color: transparentize(palette(black, base, true), 0.15) !important;

		.expose__container,
		.expose__content
		{
			width: 100%;
			height: 100%;
		}

		.expose__container
		{
			padding: 0 rem(88);
		}

		.expose__close
		{
			top: rem(16);
			right: rem(24);
			transform: none;
			background-color: palette(font);
			color: palette(white);
		}

		&__game
		{
			height: 100%;

			.game-demo__container
			{
				height: 100%;

				&:before
				{
					display: none;
				}
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/organisms/GameDemoExpose.vue